import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { GuiConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { DefaultService } from './api/default.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class GuiApiModule {
    public static forRoot(configurationFactory: () => GuiConfiguration): ModuleWithProviders<GuiApiModule> {
        return {
            ngModule: GuiApiModule,
            providers: [ { provide: GuiConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: GuiApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('GuiApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
